import * as React from "react";

import { withStyles } from '@material-ui/core/styles';
import Typography from "@material-ui/core/Typography";
import Pagina1 from "./Pagina1";
import Pagina2 from "./Pagina2";
import Pagina3 from "./Pagina3";
import Pagina4 from "./Pagina4";
import Pagina5 from "./Pagina5";
import Pagina6 from "./Pagina6";


const styles = (theme) => ({
  pagebreak: {
    marginTop: '1rem',
    display: 'block',
    pageBreakBefore: 'always'
  }

});

class TemplateRaspaProducaoPdf extends React.PureComponent {

  constructor(props: Props) {
    super(props);

    this.state = { checked: false };
  }

  render() {
    const {
      classes,
      raspaReportData,
      filter,
        isLoading

    } = this.props;


    if (typeof(raspaReportData) === "undefined" || isLoading || raspaReportData === null )
    {
      return (<Typography>Aguarde...</Typography>);
    }


    return (
        <div>
            <Pagina1 raspaReportData={raspaReportData} filter={filter} isLoading={isLoading}/>
            <div className="pagebreak"></div>
            <Pagina2 raspaReportData={raspaReportData} filter={filter} isLoading={isLoading}/>
            <div className="pagebreak"></div>
            <Pagina3 raspaReportData={raspaReportData} filter={filter} isLoading={isLoading}/>
            <div className="pagebreak"></div>
            <Pagina4 raspaReportData={raspaReportData} filter={filter} isLoading={isLoading}/>
            <div className="pagebreak"></div>
            <Pagina5 raspaReportData={raspaReportData} filter={filter} isLoading={isLoading}/>
            <div className="pagebreak"></div>
            <Pagina6 raspaReportData={raspaReportData} filter={filter} isLoading={isLoading}/>
        </div>
    );
  }
}

const WithStyleTemplateRaspaProducaoPdf = ((withStyles(styles, {withTheme: true}))(TemplateRaspaProducaoPdf))
export const FCTemplateRaspaProducaoPdfToPrint = React.forwardRef((props, ref) => { // eslint-disable-line max-len
  return <WithStyleTemplateRaspaProducaoPdf ref={ref} {...props} />;
});